import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logout } from '../actions/auth';
import '../../assets/scss/error-page.scss';

const Logout = props => {
    useEffect(() => {
        props.actions.logout();
    }, []);

    return <div className="page">
        <div className="page-content">
            <h3 className="page-text">Redirecting...</h3>
        </div>
    </div>;
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ logout }, dispatch)
});

export default connect(null, mapDispatchToProps)(Logout);